<template lang="">
  <div class="relative w-full bg-white z-50">
    <section class="shadow-md py-3 lg:py-2 shadow-[#00000029] hidden md:block">
      <div class="fixed top-0 bg-white w-full shadow-md">
        <div class="scroll-text">
          <span>
            Precautions to be taken by the students before enrolling in
            programmes offered under Open & Distance Learning (ODL) and/or
            Online Learning mode -
            <a
              href="https://api.vignanonline.com/media/UGC_20240319152222_1.pdf"
              target="blank"
              class="text-[#d02829]"
            >
              Link
            </a>
          </span>
          <!-- <span class="px-4"> | </span> -->
        </div>
        <div class="w-full mx-auto max-w-6xl relative p-3">
          <div class="flex justify-between items-center gap-20">
            <div class="flex justify-center items-center">
              <router-link :to="{ name: 'home' }">
                <img
                  src="@/assets/vignan-logo.webp"
                  width="339px"
                  height="70px"
                  class="W-[280px]"
                  alt="Vignan-Logo"
                  fetchPriority="high"
                />
              </router-link>
            </div>

            <div
              class="flex justify-center gap-2 md:gap-10 items-center w-[80%]"
            >
              <div
                class="font-semibold text-black text-[10px] md:text-[14px] lg:text-[14px]"
              >
                <router-link to="/about-us">ABOUT US</router-link>
              </div>
              <div
                class="cursor-pointer font-semibold text-black text-[10px] md:text-[14px] lg:text-[14px]"
              >
                <p @click="toggleDiv">
                  PROGRAMS
                  <font-awesome-icon icon="fa-solid fa-angle-down" size="lg" />
                </p>
                <div
                  v-if="showDiv"
                  class="w-full mx-auto max-w-5xl h-[530px] top-24 left-0 p-4 bg-white absolute"
                >
                  <div
                    class="flex justify-start gap-12 w-full mx-auto max-w-5xl border-b-2 border-[#d02829]"
                  >
                    <div
                      @click="setActiveTab('bachelors')"
                      :class="{
                        'active-tab border-b-4 border-b-[#d02829]':
                          activeTab === 'bachelors',
                      }"
                      class="w-[150px] shadow-md text-[15px] border px-8 py-4 rounded-t-md border-gray-300 hover:border-b-4 hover:border-b-[#d02829]"
                    >
                      BACHELORS
                    </div>
                    <div
                      @click="setActiveTab('masters')"
                      :class="{
                        'active-tab border-b-4 border-b-[#d02829]':
                          activeTab === 'masters',
                      }"
                      class="[w-[150px] shadow-md text-[15px] border px-8 py-4 rounded-t-md border-gray-300 hover:border-b-4 hover:border-b-[#d02829]"
                    >
                      MASTERS
                    </div>

                    <div
                      class="flex justify-end items-center w-full"
                      @click="closeDiv"
                    >
                      <img src="@/assets/home/close-btn.webp" />
                    </div>
                  </div>
                  <div class="w-full mx-auto max-w-5xl pt-1 flex">
                    <div class="w-1/2">
                      <div class="flex flex-col justify-start h-[400px]">
                        <!-- Content for BACHELORS tab -->

                        <div v-if="activeTab === 'bachelors'">
                          <div class="flex">
                            <div
                              class="font-medium px-10 py-2 hover:bg-[#E5EBF0] hover:text-[#CA2526]"
                              @click="selectedDegree = 'BBA'"
                              :class="[
                                selectedDegree == 'BBA'
                                  ? 'bg-[#E5EBF0] text-[#CA2526]'
                                  : 'bg-white text-black',
                              ]"
                            >
                              BBA
                            </div>
                            <div
                              class="font-medium px-10 py-2 hover:bg-[#E5EBF0] hover:text-[#CA2526]"
                              @click="selectedDegree = 'BCA'"
                              :class="[
                                selectedDegree == 'BCA'
                                  ? 'bg-[#E5EBF0] text-[#CA2526]'
                                  : 'bg-white text-black',
                              ]"
                            >
                              BCA
                            </div>
                          </div>
                          <div class="bg-[#d02829] relative">
                            <img
                              src="../assets/bachelors.webp"
                              alt=""
                              class="w-[276px]"
                            />
                            <p class="text-white absolute right-2 top-56">
                              #DrivingYourFuture
                            </p>
                          </div>
                        </div>
                        <div v-if="activeTab === 'masters'">
                          <!-- Content for MASTERS tab -->
                          <div class="flex flex-col justify-start">
                            <div class="flex">
                              <div
                                class="bg-[#E5EBF0] font-medium px-10 py-2 hover:bg-[#E5EBF0] hover:text-[#CA2526]"
                                @click="selectedDegree = 'MBA'"
                                :class="[
                                  selectedDegree == 'MBA'
                                    ? 'bg-[#E5EBF0] text-[#CA2526]'
                                    : 'bg-white text-black',
                                ]"
                              >
                                MBA
                              </div>
                              <div
                                class="bg-[#E5EBF0] font-medium px-10 py-2 hover:bg-[#E5EBF0] hover:text-[#CA2526]"
                                @click="selectedDegree = 'MCA'"
                                :class="[
                                  selectedDegree == 'MCA'
                                    ? 'bg-[#E5EBF0] text-[#CA2526]'
                                    : 'bg-white text-black',
                                ]"
                              >
                                MCA
                              </div>
                            </div>
                            <div class="bg-[#d02829] relative">
                              <img
                                src="../assets/Master-Programs.webp"
                                alt="Masters Program"
                                class="w-[335px]"
                              />
                              <p class="text-white absolute right-2 top-56">
                                #DrivingYourFuture
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="w-1/2">
                      <!-- Display the selected degree content -->
                      <div
                        class="flex flex-col"
                        v-if="
                          activeTab === 'bachelors' && selectedDegree === 'BBA'
                        "
                      >
                        <div class="text-left p-4 w-full">
                          <a
                            href="/bachelors-business-administration-online-degree"
                            class="text-[13px] w-full font-semibold hover:bg-[#d02829] hover:text-white hover:py-1 hover:px-2 block"
                            >Online BBA Degree</a
                          >
                        </div>
                        <div class="electives text-left p-2">
                          <ul>
                            <p class="text-[12px] font-normal">Electives</p>
                            <a href="/online-bba/general">
                              <li
                                class="uppercase ele bg-[#d02829] text-white hover:px-2 block text-xs font-medium"
                              >
                              Bachelor of Business Administration
                              </li></a
                            >
                          </ul>
                        </div>
                      </div>
                      <div
                        v-else-if="
                          activeTab === 'bachelors' && selectedDegree === 'BCA'
                        "
                      >
                        <div class="text-left p-4 w-full">
                          <a
                            href="/bachelor-computer-application-online-degree"
                            class="text-[13px] w-full font-semibold hover:bg-[#d02829] hover:text-white hover:py-1 hover:px-2 block"
                            >Online BCA Degree</a
                          >
                        </div>
                        <div class="electives text-left p-2">
                          <ul>
                            <p class="text-[12px] font-normal">Electives</p>
                            <a href="/online-bca/computer-science-it">
                              <li
                                class="uppercase ele bg-[#d02829] text-white hover:px-2 block text-xs font-medium"
                              >
                                Computer Science and Information Technology
                              </li></a
                            >
                          </ul>
                        </div>
                      </div>
                      <div
                        v-if="
                          activeTab === 'masters' && selectedDegree === 'MBA'
                        "
                      >
                        <div class="text-left p-4 w-full">
                          <a
                            href="/masters-business-administration-online-degree"
                            class="text-[13px] w-full font-semibold hover:bg-[#d02829] hover:text-white hover:py-1 hover:px-2 block"
                            >Online MBA Degree</a
                          >
                        </div>
                        <div class="electives text-left p-2">
                          <ul>
                            <p
                              class="md:text-[14px] text-[#d02829] pl-2 text-[12px] font-semi-bold"
                            >
                              Electives and Advanced Certifications
                            </p>

                            <a href="/online-mba/marketing">
                              <li
                                class="ele hover:bg-[#d02829] hover:text-white hover:px-2 block uppercase text-xs font-medium"
                              >
                                Marketing
                              </li></a
                            >

                            <a href="/online-mba/finance">
                              <li
                                class="ele hover:bg-[#d02829] hover:text-white hover:px-2 block uppercase text-xs font-medium"
                              >
                                Finance
                              </li>
                            </a>

                            <a href="/online-mba/human-resource-management">
                              <li
                                class="ele hover:bg-[#d02829] hover:text-white hover:px-2 block uppercase text-xs font-medium"
                              >
                                Human Resource Management
                              </li>
                            </a>
                            <a href="/online-mba/business-analytics">
                              <li
                                class="ele hover:bg-[#d02829] hover:text-white hover:px-2 block uppercase text-xs font-medium"
                              >
                                Business Analytics
                              </li>
                            </a>

                            <a href="/online-mba/finance-and-human-resource">
                              <li
                                class="ele hover:bg-[#d02829] hover:text-white hover:px-2 block uppercase text-xs font-medium"
                              >
                                Finance and human resource management
                              </li>
                            </a>
                            <a href="/online-mba/information-technology">
                              <li
                                class="ele hover:bg-[#d02829] hover:text-white hover:px-2 block uppercase text-xs font-medium"
                              >
                                Information TechNology
                              </li>
                            </a>

                            <a
                              href="/online-mba/healthcare-and-hospital-management"
                            >
                              <li
                                class="ele hover:bg-[#d02829] hover:text-white hover:px-2 block uppercase text-xs font-medium"
                              >
                                Healthcare and hospital management
                              </li></a
                            >
                          </ul>
                        </div>
                      </div>
                      <div
                        v-else-if="
                          activeTab === 'masters' && selectedDegree === 'MCA'
                        "
                      >
                        <div class="text-left p-4 w-full">
                          <a
                            href="/masters-computer-applications-online-degree"
                            class="text-[13px] w-full font-semibold hover:bg-[#d02829] hover:text-white hover:py-1 hover:px-2 block"
                            >Online MCA Degree</a
                          >
                        </div>
                        <div class="electives text-left p-2">
                          <ul>
                            <p
                              class="md:text-[14px] text-[#d02829] pl-2 text-[12px] font-semi-bold"
                            >
                              Electives and Advanced Certifications
                            </p>
                            <a href="/online-mca/computer-science-and-it">
                              <li
                                class="ele hover:bg-[#d02829] hover:text-white hover:px-2 block uppercase text-xs font-medium"
                              >
                                Computer Science and Information Technology
                              </li></a
                            >
                            <a href="/online-mca/data-science">
                              <li
                                class="ele hover:bg-[#d02829] hover:text-white hover:px-2 block uppercase text-xs font-medium"
                              >
                                Data science
                              </li>
                            </a>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                @click="openModal"
                class="font-semibold cursor-pointer text-white p-3 bg-[#d02829] text-[14px] hover:bg-white hover:text-[#D02829] hover:border-2 hover:border-[#d02829] rounded-3xl"
              >
                ENQUIRE NOW
              </div>
              <div
                class="font-semibold text-black cursor-pointer text-[8px] md:text-[13px]"
              >
                <a href="https://apply.vignanonline.com/" target="_blank"><p>APPLY NOW</p></a>
              </div>
              <div class="hamburger-menu">
                <button
                  @click="toggleMenu"
                  :class="{ active: isOpen }"
                  id="dhm"
                  aria-label="hamburger"
                >
                  <div class="bar"></div>
                  <div class="bar"></div>
                  <div class="bar"></div>
                </button>
                <ul :class="{ show: isOpen }" class="formup">
                  <a href="/blogs"
                    ><li
                      class="hover:bg-[#CA2526] hover:text-white text-[13px] font-medium"
                    >
                      BLOGS
                    </li></a
                  >
                  <a href="/contact-us"
                    ><li
                      class="hover:bg-[#CA2526] hover:text-white text-[13px] font-medium"
                    >
                      CONTACT US
                    </li></a
                  >
                  <a href="https://support.vignanonline.com" target="blank"
                    ><li
                      class="hover:bg-[#CA2526] hover:text-white text-[13px] font-medium"
                    >
                      STUDENT SUPPORT
                    </li></a
                  >
                  <a
                    href="https://refer.vignanonline.com/?utm_source=reference&utm_medium=Website&utm_campaign=Button"
                    target="blank"
                    ><li
                      class="hover:bg-[#CA2526] hover:text-white text-[13px] font-medium"
                    >
                      REFER A FRIEND
                    </li></a
                  >
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- MobileView -->
    <section class="md:hidden fixed bg-white shadow-md w-full">
      <div class="flex justify-between p-5">
        <div class="">
          <router-link :to="{ name: 'home' }">
            <img
              src="@/assets/vignan-logo.webp"
              alt="Vignan Online Logo"
              width="339px"
              height="70px"
              fetchPriority="high"
              class="w-[220px] h-[50px]"
              title="Vignan Online Logo"
            />
          </router-link>
        </div>

        <div class="hamburger-menu">
          <button
            @click="toggleMenu"
            :class="{ active: isOpen }"
            id="mhm"
            aria-label="hamburger"
          >
            <div class="bar"></div>
            <div class="bar"></div>
            <div class="bar"></div>
          </button>
          <div
            :class="{ show: isOpen }"
            class="drop w-full bg-white cursor-pointer fixed top-20 z-50 h-[500px] overflow-scroll pb-4"
          >
            <!-- Tabbed Content Section -->
            <div class="w-full">
              <div
                class="flex justify-start gap-5 w-full border-b-2 border-[#d02829]"
              >
                <div
                  @click="setActiveTab('bachelors')"
                  :class="{
                    'active-tab border-b-4 border-b-[#d02829]':
                      activeTab === 'bachelors',
                  }"
                  class="w-[150px] shadow-md text-[13px] font-bold border px-8 py-4 rounded-t-md border-gray-300 hover:border-b-4 hover:border-b-[#d02829]"
                >
                  BACHELORS
                </div>
                <div
                  @click="setActiveTab('masters')"
                  :class="{
                    'active-tab border-b-4 border-b-[#d02829]':
                      activeTab === 'masters',
                  }"
                  class="w-[150px] shadow-md text-[13px] font-bold border px-8 py-4 rounded-t-md border-gray-300 hover:border-b-4 hover:border-b-[#d02829]"
                >
                  MASTERS
                </div>
              </div>
              <div class="w-full mx-auto max-w-5xl pt-1 flex flex-col">
                <div>
                  <!-- Content for BACHELORS tab -->

                  <div class="flex flex-col justify-center">
                    <div v-if="activeTab === 'bachelors'">
                      <div class="flex">
                        <div
                          class="font-normal px-10 py-2"
                          @click="selectedDegree = 'BBA'"
                          :class="[
                            selectedDegree == 'BBA'
                              ? 'bg-[#E5EBF0] text-[#CA2526]'
                              : 'bg-white text-black',
                          ]"
                        >
                          BBA
                        </div>
                        <div
                          class="font-normal px-10 py-2"
                          @click="selectedDegree = 'BCA'"
                          :class="[
                            selectedDegree == 'BCA'
                              ? 'bg-[#E5EBF0] text-[#CA2526]'
                              : 'bg-white text-black',
                          ]"
                        >
                          BCA
                        </div>
                      </div>
                    </div>
                    <div v-if="activeTab === 'masters'">
                      <!-- Content for MASTERS tab -->
                      <div class="flex flex-col justify-start">
                        <div class="flex">
                          <div
                            class="bg-[#E5EBF0] font-normal px-10 py-2 hover:bg-[#E5EBF0] hover:text-[#CA2526]"
                            @click="selectedDegree = 'MBA'"
                            :class="[
                              selectedDegree == 'MBA'
                                ? 'bg-[#E5EBF0] text-[#CA2526]'
                                : 'bg-white text-black',
                            ]"
                          >
                            MBA
                          </div>
                          <div
                            class="bg-[#E5EBF0] font-normal px-10 py-2 hover:bg-[#E5EBF0] hover:text-[#CA2526]"
                            @click="selectedDegree = 'MCA'"
                            :class="[
                              selectedDegree == 'MCA'
                                ? 'bg-[#E5EBF0] text-[#CA2526]'
                                : 'bg-white text-black',
                            ]"
                          >
                            MCA
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <!-- Display the selected degree content -->
                  <div
                    v-if="activeTab === 'bachelors' && selectedDegree === 'BBA'"
                  >
                    <div class="text-left p-2 mt-5 w-full">
                      <a
                        href="/bachelors-business-administration-online-degree"
                        class="text-[13px] w-full font-semibold hover:bg-[#d02829] hover:text-white hover:px-2 block"
                        >Online BBA Degree</a
                      >
                    </div>
                    <div class="electives text-left p-0">
                      <ul>
                        <p class="text-[12px]">Electives</p>
                        <a href="/online-bba/general"
                          ><li
                            class="ele hover:bg-[#d02829] hover:text-white hover:px-2 block uppercase"
                          >
                          Bachelor of Business Administration
                          </li></a
                        >
                      </ul>
                    </div>
                  </div>
                  <div
                    v-else-if="
                      activeTab === 'bachelors' && selectedDegree === 'BCA'
                    "
                  >
                    <div class="text-left p-2 mt-5 w-full">
                      <a
                        href="/bachelor-computer-application-online-degree"
                        class="text-[13px] w-full font-semibold hover:bg-[#d02829] hover:text-white hover:px-2 block"
                        >Online BCA Degree</a
                      >
                    </div>
                    <div class="electives text-left p-0">
                      <ul>
                        <p class="text-[12px]">Electives</p>
                        <a href="/online-bca/computer-science-it"
                          ><li
                            class="ele hover:bg-[#d02829] hover:text-white hover:px-2 block uppercase"
                          >
                            Computer Science and Information Technology
                          </li></a
                        >
                      </ul>
                    </div>
                  </div>
                  <div
                    v-if="activeTab === 'masters' && selectedDegree === 'MBA'"
                  >
                    <div class="text-left p-2 mt-5 w-full">
                      <a
                        href="/masters-business-administration-online-degree"
                        class="text-[13px] w-full font-semibold hover:bg-[#d02829] hover:text-white hover:px-2 block"
                        >Online MBA Degree</a
                      >
                    </div>
                    <div class="electives text-left p-0">
                      <ul>
                        <p
                          class="md:text-[14px] text-[#d02829] pl-2 text-[12px] font-semi-bold"
                        >
                          Electives and Advanced Certifications
                        </p>

                        <a href="/online-mba/marketing"
                          ><li
                            class="ele hover:bg-[#d02829] hover:text-white hover:px-2 block uppercase"
                          >
                            Marketing
                          </li></a
                        >
                        <a href="/online-mba/finance"
                          ><li
                            class="ele hover:bg-[#d02829] hover:text-white hover:px-2 block uppercase"
                          >
                            Finance
                          </li></a
                        >

                        <a href="/online-mba/human-resource-management"
                          ><li
                            class="ele hover:bg-[#d02829] hover:text-white hover:px-2 block uppercase"
                          >
                            Human resource management
                          </li></a
                        >

                        <a href="/online-mba/business-analytics"
                          ><li
                            class="ele hover:bg-[#d02829] hover:text-white hover:px-2 block uppercase"
                          >
                            Business Analytics
                          </li></a
                        >

                        <a href="/online-mba/finance-and-human-resource">
                          <li
                            class="ele hover:bg-[#d02829] hover:text-white hover:px-2 block uppercase"
                          >
                            Finance and human resource management
                          </li></a
                        >
                        <a href="/online-mba/information-technology">
                          <li
                            class="ele hover:bg-[#d02829] hover:text-white hover:px-2 block uppercase"
                          >
                            Information TechNology
                          </li></a
                        >
                        <a
                          href="/online-mba/healthcare-and-hospital-management"
                        >
                          <li
                            class="ele hover:bg-[#d02829] hover:text-white hover:px-2 block uppercase"
                          >
                            Healthcare and hospital management
                          </li></a
                        >
                      </ul>
                    </div>
                  </div>
                  <div
                    v-else-if="
                      activeTab === 'masters' && selectedDegree === 'MCA'
                    "
                  >
                    <div class="text-left p-2 mt-5 w-full">
                      <a
                        href="/masters-computer-applications-online-degree"
                        class="text-[13px] w-full font-semibold hover:bg-[#d02829] hover:text-white hover:px-2 block"
                        >Online MCA Degree</a
                      >
                    </div>
                    <div class="electives text-left p-0">
                      <ul>
                        <p
                          class="md:text-[14px] text-[#d02829] pl-2 text-[12px] font-semi-bold"
                        >
                          Electives and Advanced Certifications
                        </p>
                        <a href="/online-mca/computer-science-and-it"
                          ><li
                            class="ele hover:bg-[#d02829] hover:text-white hover:px-2 block uppercase"
                          >
                            Computer Science and Information Technology
                          </li></a
                        >
                        <a href="/online-mca/data-science"
                          ><li
                            class="ele hover:bg-[#d02829] hover:text-white hover:px-2 block uppercase"
                          >
                            Data science
                          </li></a
                        >
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Links Section -->
            <div
              class="bg-[#d8d7d7] text-xs font-medium w-full p-4 flex flex-col gap-4"
            >
              <a href="/blogs"
                ><div class="border-b border-b-[#ccc]">BLOGS</div></a
              >
              <a href="/contact-us"
                ><div class="border-b border-b-[#ccc]">CONTACT US</div></a
              >
              <a href="https://support.vignanonline.com" target="blank"
                ><div class="border-b border-b-[#ccc]">STUDENT SUPPORT</div></a
              >
              <a
                href="https://refer.vignanonline.com/?utm_source=reference&utm_medium=Website&utm_campaign=Button"
                ><div class="">REFER A FRIEND</div></a
              >
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Modal -->
    <!-- <div class="Emodal" v-if="isModalOpen">
      <div
        class="Emodal-content z-50 rounded-md relative bottom-24 w-[90%] md:w-[35%] 2xl:w-[20%]"
      >
        <span class="close" @click="closeModal">&times;</span>
        <EnquireView />
      </div>
    </div> -->
    <EnquireView v-if="isModalOpen" @closeModal="closeModal" />
  </div>
</template>
<script>
import axios from "axios";
import { useHead } from "@unhead/vue";
import EnquireView from "@/components/EnquireForm.vue";
export default {
  components: {
    EnquireView,
  },

  data() {
    return {
      isOpen: false,
      showDiv: false,
      activeTab: "bachelors", // Initialize activeTab to 'bachelors'
      selectedDegree: "BBA", // Initialize the selected degree
      isModalOpen: false,
    };
  },

  created() {
    this.initializeUtmParameters();
  },

  async mounted() {
    document.addEventListener("click", this.closeDivOnClickOutside);
    const seoTag = await this.bindMetaTags();

    // Ensure that you use the schema from seoTag
    useHead({
      title: seoTag.title,
      meta: seoTag.meta,
      link: seoTag.link,
      script: seoTag.script, // Use seoTag.script here
    });
  },

  methods: {
    initializeUtmParameters() {
      // Capture UTM parameters from the URL
      const utmParams = this.getUtmParameters(this.$route.query);
      if (this.hasUtmParams(utmParams)) {
        localStorage.setItem("utmParams", JSON.stringify(utmParams));
        let currentDate = new Date();
        let dateOnly = currentDate.toISOString().split("T")[0];
        localStorage.setItem("utmParamsStoreDate", JSON.stringify(dateOnly));
      }
    },

    getUtmParameters(query) {
      // Extract UTM parameters from query object
      return {
        utmSource: query.utm_source || null,
        utmSourceCampaign: query.utm_campaign || null,
        utmSourceMedium: query.utm_medium || null,
        utmAdgroupid: query.utm_adgroupid || null,
        utmCampaignid: query.utm_campaignid || null,
        utmCreativeid: query.utm_creativeid || null,
        utmDevice: query.utm_device || null,
        utmKeyword: query.utm_keyword || null,
        utmMatchtype: query.utm_matchtype || null,
        utmNetwork: query.utm_network || null,
        utmPlacement: query.utm_placement || null,
        utmGclid: query.gclid || null,
      };
    },

    hasUtmParams(utmParams) {
      // Check if there are any non-null UTM parameters
      return Object.values(utmParams).some((param) => param !== null);
    },

    async bindMetaTags() {
      const metaTagDic = {
        meta: [],
        link: [],
        title: "",
        script: [],
      };

      try {
        const resp = await axios.get(
          `${process.env.VUE_APP_API}/seo-list/?url=${this.$route.path}`
        );

        if (
          resp.data.status === 200 &&
          resp.data.data &&
          resp.data.data.length > 0
        ) {
          const result = resp.data.data[0];
          metaTagDic.title = result.title;

          metaTagDic.meta = [
            { name: "description", content: result.description },
            { name: "keywords", content: result.keyword.join(",") },
            { name: "og:title", content: result.og_title },
            { name: "og:image", content: result.og_img },
            { name: "og:description", content: result.og_description },
            { name: "twitter:title", content: result.twitter_title },
            { name: "twitter:image", content: result.twitter_img },
            { name: "twitter:card", content: result.twitter_card },
          ];

          metaTagDic.link = [
            {
              rel: "canonical",
              href: `https://vignanonline.com${this.$route.fullPath}`,
            },
          ];

          //     try {
          //       let schemaData;
          //       if (typeof result.schema_code === 'string') {
          //         schemaData = JSON.parse(result.schema_code);
          //       } else if (Array.isArray(result.schema_code)) {
          //         schemaData = result.schema_code;
          //       } else {
          //         schemaData = [result.schema_code]; // If it's a single object
          //       }

          //       if (Array.isArray(schemaData) && schemaData.length > 0) {
          //         metaTagDic.script = schemaData.map(item => ({
          //           type: "application/ld+json",
          //           innerHTML: JSON.stringify(item)
          //         }));
          //       }
          //     } catch (error) {
          //       console.error("Invalid JSON data for schema:", error);
          //     }
          //   }
          // } catch (error) {
          //   console.error("Failed to fetch SEO data:", error);
          // }

          // return metaTagDic;
          try {
            let schemaData;
            if (typeof result.schema_code === "string") {
              schemaData = JSON.parse(result.schema_code);
            } else if (Array.isArray(result.schema_code)) {
              schemaData = result.schema_code;
            } else {
              schemaData = [result.schema_code]; // If it's a single object
            }

            if (Array.isArray(schemaData)) {
              schemaData.forEach((item) => {
                if (item) {
                  // Check if the item is not null or undefined
                  metaTagDic.script.push({
                    type: "application/ld+json",
                    innerHTML: JSON.stringify(item),
                  });
                }
              });
            } else if (schemaData) {
              // Handle case where schemaData is a single object
              metaTagDic.script.push({
                type: "application/ld+json",
                innerHTML: JSON.stringify(schemaData),
              });
            }
          } catch (error) {
            console.error("Invalid JSON data for schema:", error);
          }
        }
      } catch (error) {
        console.error("Failed to fetch SEO data:", error);
      }

      return metaTagDic;
    },

    toggleMenu() {
      this.isOpen = !this.isOpen;
    },
    toggleDiv() {
      this.showDiv = !this.showDiv;
    },
    closeDiv() {
      this.showDiv = false;
    },

    closeDivOnClickOutside(event) {
      if (this.showDiv && !this.$el.contains(event.target)) {
        this.showDiv = false;
      }
    },

    setActiveTab(tab) {
      this.activeTab = tab;
      // Set the default selected degree based on the active tab
      if (tab === "bachelors") {
        this.selectedDegree = "BBA";
      } else if (tab === "masters") {
        this.selectedDegree = "MBA";
      }
    },

    openModal() {
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
    },
  },

  beforeUnmount() {
    document.removeEventListener("click", this.closeDivOnClickOutside);
  },
};
</script>

<style scoped>
.hamburger-menu {
  position: relative;
}

button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 10px;
  outline: none;
  position: relative;
}

.bar {
  background-color: #333;
  height: 2px;
  margin: 4px 0;
  transition: 0.4s;
  width: 25px;
}

.active .bar:nth-child(1) {
  transform: rotate(-45deg) translate(-5px, 6px);
}

.active .bar:nth-child(2) {
  opacity: 0;
}

.active .bar:nth-child(3) {
  transform: rotate(45deg) translate(-5px, -6px);
}

.formup {
  list-style-type: none;
  padding: 10px;
  position: absolute;
  top: 66px;
  right: 0;
  background-color: #fff;
  border-top: none;
  display: none;
  min-width: 350px;
  text-align: left;
}

ul.show {
  display: block;
}

ul li {
  padding: 10px;
  border-bottom: #ccc 1px solid;
}

.drop {
  padding: 10px;
  right: 0;
  display: none;
  min-width: 350px;
  text-align: left;
}

.drop.show {
  display: block;
}

#scroll-container {
  overflow: hidden;
}

.scroll-text {
  color: #001c50;
  font-size: 15px;
  font-weight: bolder;
  white-space: nowrap;
}

@media (max-width: 480px) {
  .scroll-text {
    color: #001c50;
    font-size: small;
    font-weight: bolder;
    white-space: nowrap;
    overflow: hidden;
  }

  .Emodal-content {
    height: 70%;
    position: relative;
    background-color: #fff;
    margin: 15% auto;
    padding: 20px;
    border: 1px solid #888;
    top: 50px;
    overflow: scroll;
  }
}

.scroll-text {
  /* animation properties */
  -moz-transform: translateX(100%);
  -webkit-transform: translateX(100%);
  transform: translateX(100%);

  -moz-animation: my-animation 10s linear infinite;
  -webkit-animation: my-animation 10s linear infinite;
  animation: my-animation 30s linear infinite;
}

.scroll-text:hover {
  -webkit-animation-play-state: paused;
  -moz-animation-play-state: paused;
  -o-animation-play-state: paused;
  animation-play-state: paused;
}

/* for Firefox */
@-moz-keyframes my-animation {
  from {
    -moz-transform: translateX(100%);
  }

  to {
    -moz-transform: translateX(-100%);
  }
}

/* for Chrome */
@-webkit-keyframes my-animation {
  from {
    -webkit-transform: translateX(100%);
  }

  to {
    -webkit-transform: translateX(-100%);
  }
}

@keyframes my-animation {
  from {
    -moz-transform: translateX(100%);
    -webkit-transform: translateX(100%);
    transform: translateX(100%);
  }

  to {
    -moz-transform: translateX(-100%);
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%);
  }
}

.Emodal {
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.Emodal-content {
  position: relative;
  background-color: white;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 750px;
}

.close {
  position: relative;
  color: #aaa;
  float: right;
  top: -25px;
  font-size: 40px;
  font-weight: bold;
  cursor: pointer;
}

.close:hover {
  color: black;
}

.electives {
  display: flex;
  flex-direction: column;
  background: none;
}

.ele {
  border: none;
  font-size: 13px;
  font-weight: 500;
}
</style>
